require('./contractLoanAccounts.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

//@components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@utilities
const {
    getFilteredAccountIndexes,
    getFirstFilteredAccountIndexThatIsnotBlocked } = require('../../../loansUtilities/loansHelper');

class ContractLoanAccounts extends React.Component {

    componentDidMount() {
        const {
            blockedAccountsContract,
            getBlockedAccounts,
            immAccounts,
            immFlagBasedFeatures,
        } = this.props;

        if (!immAccounts.get('blockedAccountsSuccess') && immFlagBasedFeatures.get('web-inactive-account-enabled')) {
            const accounts = getFilteredAccountIndexes(immAccounts).map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, blockedAccountsContract);
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immAccounts,
            immFlagBasedFeatures,
            selectedAccount,
            setSelectedAccount,
        } = this.props;

        if ((immAccounts.get('blockedAccountsSuccess') !== prevProps.immAccounts.get('blockedAccountsSuccess') || !immFlagBasedFeatures.get('web-inactive-account-enabled')) &&
            !selectedAccount) {
            const nonBlockedAccounts = getFirstFilteredAccountIndexThatIsnotBlocked(immAccounts);
            if (nonBlockedAccounts) {
                const notSetAccountInDidUpdate = true;
                const isCalledonMount = false;
                setSelectedAccount(nonBlockedAccounts, isCalledonMount, notSetAccountInDidUpdate);
            }
        }
    }

    render() {
        const { immAccounts, setSelectedAccount, selectedAccount, disclaimer, errorSelectedAccount, errorMsgSelectedAccount, onOpenDropDown } = this.props;
        const accountSelectLabel = formatText('contractLoanAccount-accountSelectLabel');
        const filteredAccountIndexes = getFilteredAccountIndexes(immAccounts);

        return !immAccounts.get('blockedAccountsLoading') ? (
            <div className="contract-loan-accounts__container" >
                <div className="contract-loan-accounts__dropdown">
                    <DropdownAccounts
                        blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                        blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                        disclaimer={disclaimer}
                        immAccounts={immAccounts.get('byId')}
                        label={accountSelectLabel}
                        accountsIndexes={filteredAccountIndexes.toJS()}
                        onAccountChange={setSelectedAccount}
                        error={errorSelectedAccount}
                        currentAccountId={selectedAccount}
                        showNegativeBalanceAccounts
                        errorMsg={errorMsgSelectedAccount}
                        onOpen={onOpenDropDown}
                    />
                </div>
                <div className="contract-loan-accounts__message">
                    <OKMessage type="informative">
                        <FormattedText value="contractLoanAccount-messageText" />
                    </OKMessage>
                </div>
            </div>
        ) : <LoadingSection />;
    }
}

ContractLoanAccounts.defaultProps = {
    handleOnOpenDropDown: () => { },
}

ContractLoanAccounts.propTypes = {
    blockedAccountsContract: PropTypes.string,
    disclaimer: PropTypes.shape({
        important: PropTypes.string,
        warning: PropTypes.string,
    }),
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    selectedAccount: PropTypes.string,
    errorSelectedAccount: PropTypes.bool,
    errorMsgSelectedAccount: PropTypes.string,
    onOpenDropDown: PropTypes.func,
};

module.exports = ContractLoanAccounts;
